import React from "react";

import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from "react-chartjs-2";

import "./Charts.css";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend);

const sortByMonth = (data, meses) =>
    data.sort((a, b) => meses.indexOf(a.x.toLowerCase()) - meses.indexOf(b.x.toLowerCase()));

const COLORS = {
    good: { border: "#BBDEFB", background: "#BBDEFB" },
    great: { border: "#90CAF9", background: "#90CAF9" },
    excellent: { border: "#64B5F6", background: "#64B5F6" },
};

const NotesChartLine = ({ usuarioId, actorsResults }) => {
    const anoAtual = new Date().getFullYear();
    const meses = Array.from({ length: 12 }, (_, i) =>
        new Date(0, i).toLocaleString("pt-BR", { month: "long" }).toLowerCase()
    );

    const categorizedScores = actorsResults
        .filter(actor => actor.usuarioId === usuarioId && actor.dataAno === anoAtual)
        .map(actor => ({ ...actor, nota: parseFloat(actor.nota) }));

    const goodScores = categorizedScores.filter(actor => actor.nota < 70);
    const greatScores = categorizedScores.filter(actor => actor.nota >= 70 && actor.nota <= 80);
    const excellentScores = categorizedScores.filter(actor => actor.nota > 80);

    const labels = meses.filter(mes =>
        categorizedScores.some(actor => actor.dataMes.toLowerCase() === mes)
    );

    const datasets = [
        {
            label: "BOM",
            data: sortByMonth(goodScores.map(actor => ({ x: actor.dataMes.toLowerCase(), y: actor.nota })), meses),
            borderColor: COLORS.good.border,
            backgroundColor: COLORS.good.background,
        },
        {
            label: "ÓTIMO",
            data: sortByMonth(greatScores.map(actor => ({ x: actor.dataMes.toLowerCase(), y: actor.nota })), meses),
            borderColor: COLORS.great.border,
            backgroundColor: COLORS.great.background,
        },
        {
            label: "EXCELENTE",
            data: sortByMonth(excellentScores.map(actor => ({ x: actor.dataMes.toLowerCase(), y: actor.nota })), meses),
            borderColor: COLORS.excellent.border,
            backgroundColor: COLORS.excellent.background,
        }
    ];

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: "#000000",
                },
                position: 'top',
                color: '#000000'
            },
            title: {
                display: true,
                text: 'Análise Temporal dos Resultados',
                color: '#000000'
            },
        },
        scales: {
            x: {
                grid: {
                    color: '#E3F2FD',
                },
                ticks: {
                    color: '#000000',
                },
                type: "category"
            },
            y: {
                grid: {
                    color: '#E3F2FD',
                },
                ticks: {
                    color: '#000000',
                },
                beginAtZero: true
            }
        },
    };

    const hasData = goodScores.length > 0 || greatScores.length > 0 || excellentScores.length > 0;

    return hasData ? <Line data={{ labels, datasets }} options={options} /> : null;
};

export default NotesChartLine;